import { useState } from 'react';
import { FaInstagram, FaFacebook } from 'react-icons/fa';
import MentionsLegales from '../MentionsLegales/MentionsLegales';
import './Footer.css';

const Footer = () => {
  const [showMentions, setShowMentions] = useState(false);

  return (
    <>
      <footer>
        <div className="footer-social">
          <a href="https://www.instagram.com/pochard.ev/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://www.facebook.com/jordan.pochard.900" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FaFacebook />
          </a>
        </div>
        <p>&copy; {new Date().getFullYear()} Pochard Espaces Verts — Tous droits réservés</p>
        <button className="footer-mentions-btn" onClick={() => setShowMentions(true)}>
          Mentions légales
        </button>
      </footer>

      {showMentions && <MentionsLegales onClose={() => setShowMentions(false)} />}
    </>
  );
};

export default Footer;
